import React, { useState, useEffect } from "react"
import axios from 'axios';
import Parser from 'html-react-parser';

const ProduitsHome = ({ product }) => {
    const products = product && [...product];
    return (
        products.map((res, index) => {
            return (
                <div key={index} className="col-md-3 bloc-home">
                    <a href={res.link}>
                        <div className="content">
                            <div className="image"> {
                                    res.images_item?.data?.attributes && <img src={`${process.env.GATSBY_API_URL_FILE}`+res.images_item.data.attributes.url} alt={res.name} />
                                }</div>
                            <div className="text">
                                <h3>{res.name}</h3>
                                <p>{res.description}</p>
                            </div>
                        </div>
                    </a>

                </div>
            )

        })

    )
}

export default ProduitsHome;